import { CurrentUser as CommonCurrentUser } from "@teamprevent/common/auth/roles";

import { Location } from "redux-little-router";
export { ADMIN_ROLES, CUSTOMER_ROLES, notCaseManagerRole, notAnySraRole, notAdministratorRole } from "@teamprevent/common/auth/roles";

export interface CurrentUser extends CommonCurrentUser {
    qualification?: string;
}

export interface Role {
    displayName: string;
    name: string;
}

export const ANONYMOUS_USER = "ANONYMOUS_USER";

const EMPLOYEE_SELF_CHECK_IN_ROUTE = "/employeeSelfCheckIn";

export const isEmployeeSelfCheckIn = (location: Location) => location?.pathname === EMPLOYEE_SELF_CHECK_IN_ROUTE;
